import { Col, Container, Row } from "react-bootstrap";
import { DiCss3, DiNodejs, DiVisualstudio } from "react-icons/di";
import {
    SiChakraui,
    SiHtml5,
    SiPostman,
    SiRedux,
    SiTestinglibrary,
    SiTypescript
} from "react-icons/si";

import { BiLinkExternal } from "react-icons/bi";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { FaReact } from "react-icons/fa";
import { GiSettingsKnobs } from "react-icons/gi";
import Github from './Github';
import React from 'react';
import { SiJavascript } from "react-icons/si";
import { VscGithub } from "react-icons/vsc";

const Skills = () => {
    return (
        <Container fluid className="skill-card" >
            <h1 id="skill" className="project-heading" style={{ marginTop: "40px" }}>
                Professional <strong className="purple">Skill-Set </strong>
            </h1>
            <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
                <Col md={2} className="project-card">
                    <Card className="skill-card-view">
                        <SiJavascript size={70} />
                        <Card.Body>
                            <Card.Title style={{ fontWeight: "bold" }}>JavaScript</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={2} className="project-card">
                    <Card className="skill-card-view">
                        <SiHtml5 size={70} />
                        <Card.Body>
                            <Card.Title style={{ fontWeight: "bold" }}>HTML</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={2} className="project-card">
                    <Card className="skill-card-view">
                        <DiCss3 size={70} />
                        {/* <Card.Img variant="top" src={} alt="card-img" /> */}
                        <Card.Body>
                            <Card.Title style={{ fontWeight: "bold" }}>CSS</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={2} className="project-card">
                    <Card className="skill-card-view">
                        <FaReact size={70} />
                        {/* <Card.Img variant="top" src={} alt="card-img" /> */}
                        <Card.Body>
                            <Card.Title style={{ fontWeight: "bold" }}>React</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={2} className="project-card">
                    <Card className="skill-card-view">
                        <SiRedux size={70} />
                        {/* <Card.Img variant="top" src={} alt="card-img" /> */}
                        <Card.Body>
                            <Card.Title style={{ fontWeight: "bold" }}>Redux</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
                <Col md={2} className="project-card">
                    <Card className="skill-card-view">
                        <SiTypescript size={70} />
                        {/* <Card.Img variant="top" src={} alt="card-img" /> */}
                        <Card.Body>
                            <Card.Title style={{ fontWeight: "bold" }}>Typescript</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={2} className="project-card">
                    <Card className="skill-card-view">
                        <DiNodejs size={70} />
                        {/* <Card.Img variant="top" src={} alt="card-img" /> */}
                        <Card.Body>
                            <Card.Title style={{ fontWeight: "bold" }}>Nodejs</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={2} className="project-card">
                    <Card className="skill-card-view">
                        <SiChakraui size={70} />
                        {/* <Card.Img variant="top" src={} alt="card-img" /> */}
                        <Card.Body>
                            <Card.Title style={{ fontWeight: "bold" }}>Chakra UI</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={2} className="project-card">
                    <Card className="skill-card-view">
                        <SiTestinglibrary size={70} />
                        {/* <Card.Img variant="top" src={} alt="card-img" /> */}
                        <Card.Body>
                            <Card.Title style={{ fontWeight: "bold" }}>Unit-Testing(Jest)</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <h1 className="project-heading">
                Tool <strong className="purple">I use </strong>
            </h1>
            <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
                <Col md={2} className="project-card">
                    <Card className="skill-card-view">
                        <DiVisualstudio size={70} />
                        <Card.Body>
                            <Card.Title style={{ fontWeight: "bold" }}>Visual Studio Code</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={2} className="project-card">
                    <Card className="skill-card-view">
                        <VscGithub size={70} />
                        <Card.Body>
                            <Card.Title style={{ fontWeight: "bold" }}>Git</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={2} className="project-card">
                    <Card className="skill-card-view">
                        <SiPostman size={70} />
                        <Card.Body>
                            <Card.Title style={{ fontWeight: "bold" }}>Postman</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={2} className="project-card">
                    <Card className="skill-card-view">
                        <GiSettingsKnobs size={70} />
                        <Card.Body>
                            <Card.Title style={{ fontWeight: "bold" }}>Linux</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={2} className="project-card">
                    <Card className="skill-card-view">
                        <GiSettingsKnobs size={70} />
                        <Card.Body>
                            <Card.Title style={{ fontWeight: "bold" }}>Heroku</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
                <Col md={2.5} className="project-card">
                    <Card className="skill-card-view">
                        <GiSettingsKnobs size={70} />
                        <Card.Body>
                            <Card.Title style={{ fontWeight: "bold" }}>Npm (Node Package Manager)</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Github />
        </Container>
    );
};

export default Skills;